module.exports = __webpack_public_path__ + "img/8.25d51d6b.jpg";